/**
 * Shared services barrel export
 * @module shared/services
 */

export { default as httpClient } from './httpClient';
export { default as apiService } from './apiService';
